export const MESSAGE_WRITER_SET_FIELD = 'MESSAGE_WRITER_SET_FIELD';
export const MESSAGE_WRITER_INPUT_CHANGED = 'MESSAGE_WRITER_INPUT_CHANGED';
